export default "__VITE_ASSET__C9SF0CJP__"